<template>
  <div class="method-wrap">
    <p>{{ st('finance.choosePaymentMethod') }}</p>
    <div class="cont">
      <span
        class="aliPay"
        @click="() => onClick('aliPay_cn')"
        :class="props.methodType === 'aliPay_cn' ? 'select' : ''"
        v-if="store.userInfo.countryCode === 'US'"
      >
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#icon-zhifubao"></use>
        </svg>
        <span>Alipay</span>
        <span class="circle-dot" v-if="props.methodType === 'aliPay_cn'"></span>
        <span class="circle" v-else></span>
      </span>
      <span
        v-if="store.userInfo.countryCode === 'US'"
        class="card"
        @click="() => onClick('card')"
        :class="props.methodType === 'card' ? 'select' : ''"
      >
        <img src="../../../../../assets/images/finance/visa@2x.png" />
        <span>{{ st('finance.paymentMethodCard') }}</span>
        <span class="circle-dot" v-if="props.methodType === 'card'"></span>
        <span class="circle" v-else></span>
      </span>
      <span
        class="paypal"
        @click="() => onClick('paypal')"
        :class="props.methodType === 'paypal' ? 'select' : ''"
      >
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#icon-paypal1"></use>
        </svg>
        <span>{{ st('finance.paymentMethodPaypal') }}</span>
        <span class="circle-dot" v-if="props.methodType === 'paypal'"></span>
        <span class="circle" v-else></span>
      </span>
      <!-- <span
        class="bank"
        :class="props.methodType === 'bank' ? 'select' : ''"
        @click="() => onClick('bank')"
      >
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#icon-yinhangka1"></use>
        </svg>
        <span>{{ st('finance.paymentMethodBankTransfer') }}</span>
        <span class="circle-dot" v-if="props.methodType === 'bank'"></span>
        <span class="circle" v-else></span>
      </span> -->
    </div>
  </div>
</template>
<script setup>
  import { useUserInfoStore } from "~/storeData/index";
  import { useSellerI18n } from '@/composables/useSellerI18n';

  const { st } = useSellerI18n();
  const props = defineProps(["methodType", "setMethodType"]);
  const store = useUserInfoStore();

  const onClick = (status) => {
    props.setMethodType(status);
  };
</script>
<style lang="less" scoped>
.method-wrap {
  > p {
    font-weight: 600;
    font-size: 20px;
    color: var(--dark-1);
    letter-spacing: 0.5px;
    line-height: 28px;
    margin-bottom: 16px;
  }
  .cont {
    display: flex;
    flex-wrap: wrap;
    .bank {
      position: relative;
      width: 328px;
      cursor: pointer;
      padding: 8px 16px;
      border: 1px solid var(--border-1);
      box-shadow: 0 1px 0 0 var(--box-shadow-2);
      border-radius: 8px;
      display: flex;
      margin-left: 16px;
      margin-top: 13px;
      &.select {
        border: 1px solid var(--primary-border-2);
        box-shadow: var(--section-box-shadow-4);
      }
      svg {
        width: 24px;
        height: 24px;
        align-self: center;
      }
      > span {
        align-self: center;
        color: var(--dark-1);
        font-weight: 500;
        font-size: 16px;
        letter-spacing: 0.5px;
        line-height: 22px;
        margin-left: 8px;
      }
    }
    .card {
      margin-left: 16px;
    }
    .paypal {
      margin-top: 13px;
    }
    
    .circle,
    .circle-dot {
      position: absolute;
      display: block;
    }
    .circle-dot {
      right: 18px;
      top: 14px;
      width: 12px;
      height: 12px;
      border-radius: 8px;
      background-color: var(--primary);
      border: 2px solid var(--color-white);
      box-shadow: 0 0 0 2px var(--primary) !important;
    }
    .circle {
      right: 16px;
      top: 12px;
      width: 16px;
      height: 16px;
      border: 1px solid var(  --border-1);
      box-shadow: 0 1px 0 0 rgba(15, 6, 41, 0.05);
      border-radius: 8px;
    }

    .card,
    .aliPay,
    .paypal {
      position: relative;
      width: 328px;
      cursor: pointer;
      padding: 8px 16px;
      border: 1px solid var(--border-1);
      box-shadow: 0 1px 0 0 var(--box-shadow-2);
      border-radius: 8px;
      display: flex;
      &.select {
        border: 1px solid var(--primary-border-2);
        box-shadow: var(--section-box-shadow-4);
      }
      > span {
        align-self: center;
        color: var(--dark-1);
        font-weight: 500;
        font-size: 16px;
        letter-spacing: 0.5px;
        line-height: 22px;
        margin-left: 8px;
      }
      img {
        width: 24px;
        height: 24px;
      }
      svg {
        width: 24px;
        height: 24px;
      }
    }
  }
}
</style>
